import { CrmEndpoint } from './endpoints/crm';
import { MemberEndpoint } from './endpoints/member';
import { PaymentsEndpoint } from './endpoints/payments';
import { QuoterEndpoint } from './endpoints/quoter';
import { TokensEndpoint } from './endpoints/tokens';
import { HttpClientInterface } from '@itk/http-client-interface';
import { QuestionnaireEndpoint } from './endpoints/questionnaire';
import { AutofillEndpoint } from './endpoints/autofill';

export class ItkDjangoApi {
  public readonly member: MemberEndpoint;
  public readonly payments: PaymentsEndpoint;
  public readonly tokens: TokensEndpoint;
  public readonly crm: CrmEndpoint;
  public readonly quoter: QuoterEndpoint;
  public readonly questionnaire: QuestionnaireEndpoint;
  public readonly autofill: AutofillEndpoint;

  constructor(
    public readonly http: HttpClientInterface,
    private readonly crmV2Context = false,
  ) {
    this.member = new MemberEndpoint(http);
    this.payments = new PaymentsEndpoint(http);
    this.tokens = new TokensEndpoint(http);
    this.crm = new CrmEndpoint(http, this.crmV2Context);
    this.quoter = new QuoterEndpoint(http);
    this.questionnaire = new QuestionnaireEndpoint(http);
    this.autofill = new AutofillEndpoint(http);
  }
}

export * from './models/questionnaire.model';
export * from './models/autofill.model';
export * from './models/crm.model';
export * from './models/quoter-requests.model';
export * from './models/member.model';
export * from './models/quoter.model';
export * from './models/payments.model';
export * from './models/error.model';
export * from './endpoints/questionnaire';
export * from './underwriting/';
